import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const SortIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13"
        fill="none"
    >
        <path
            fill="currentColor"
            d="M7.542 11.833a.667.667 0 1 0 1.333 0V2.717l2 1.896a.667.667 0 0 0 .917-.967L8.667.683a.667.667 0 0 0-1.125.484v10.666ZM4.458 1.167a.667.667 0 1 0-1.333 0v9.116l-2-1.896a.667.667 0 0 0-.917.967l3.125 2.963a.667.667 0 0 0 1.125-.484V1.167Z"
        />
    </svg>
);